<template>
  <div>
    <a-select v-model="filter" style="width:160px; margin-bottom:8px" @change="load">
      <a-select-option value="">全部类型</a-select-option>
      <a-select-option value="dns">DNS</a-select-option>
      <a-select-option value="cert">CERT</a-select-option>
      <a-select-option value="vt">VT</a-select-option>
      <a-select-option value="whois">WHOIS</a-select-option>
    </a-select>
    <a-timeline>
      <a-timeline-item v-for="(c, i) in items" :key="i" :color="dotColor(c.status)">
        <small>{{ fmt(c.checked_at) }} · <b>{{ c.check_type }}</b> · {{ c.status }}</small>
        <pre v-if="c.detail" style="font-size:11px; background:#fafafa; padding:4px; margin:4px 0">{{ JSON.stringify(c.detail, null, 2) }}</pre>
        <small v-if="c.error" style="color:#ff4d4f">{{ c.error }}</small>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { fetchChecks } from '@/api/admin-domains'

const DOT_COLOR = { healthy: 'green', warning: 'orange', critical: 'red', unknown: 'gray', error: 'red' }

export default {
  name: 'HistoryTimeline',
  props: { domainId: Number },
  data() { return { items: [], filter: '' } },
  mounted() { this.load() },
  methods: {
    fmt(ts) { return dayjs(ts * 1000).format('YYYY-MM-DD HH:mm') },
    dotColor(s) { return DOT_COLOR[s] || 'gray' },
    async load() {
      try {
        const r = await fetchChecks(this.domainId, this.filter, 100)
        // httpClient 已解包到 envelope（{status,message,data}），业务数据在 r.data
        const root = r && r.data ? r.data : r
        this.items = (root && root.items) || []
      } catch (e) {
        console.warn('history load fail', e)
      }
    },
  },
}
</script>
